const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/newsletter/posts/$id/overview.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { newsletterRoutes } from "@circle-react/lib/routes/newsletter";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { fetchNewsletterPost } from "@/react/components/SettingsApp/Newsletters/helpers";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/newsletter/posts/$id/overview")({
  beforeLoad: async ({
    params,
    context
  }) => {
    const post = await fetchNewsletterPost(context.queryClient, params.id);

    // Draft overview URLs go to Design before the page renders.
    if (post?.status !== "draft") return;
    redirect({
      href: newsletterRoutes.postContent({
        path: {
          id: params.id
        }
      }),
      replace: true,
      throw: true
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});